import React, { useState } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { toastHandler } from "../../utils/helpers";
import { toastTypesKeys } from "../../utils/constants";
import { ToastContainer } from "react-toastify";
import { Autocomplete, Modal, TextField } from "@mui/material";
import { PersonNew } from "../../pages";
import { ConditionalRenderer, useLanguageTranslator } from "../../components";
import { ModalCloseIcon } from "../../@lib/icons";

export type PeopleInfoFormProps = {
  disabled?: boolean;
  data?: any;
  state?: any;
  setState?: any;
  onClickHandler?: any;
};

const PeopleInfoForm: React.FC<PeopleInfoFormProps> = ({
  data,
  state,
  setState,
  onClickHandler,
}: any) => {
  const [selectedValue, setSelectedValue] = useState<string | null>(null);
  // const [selectedListPractices, setSelectedListPractices] = useState<any>([]);

  const { translator } = useLanguageTranslator();

  const handleValueChange = (event: any, newValue: any) => {
    setSelectedValue(newValue);

    if (newValue === null) return;

    const isDuplicate = state.some(
      (item: any) => item?.value === newValue?.value
    );

    if (isDuplicate) {
      toastHandler("Already Selected", toastTypesKeys.error);
      return;
    }

    setState([...state, newValue]);
  };

  function handleRemoveClick(value: string) {
    const modifiedSelectedListPractices = state?.filter(
      (item: any) => item.value !== value
    );
    setState(modifiedSelectedListPractices);
  }
  return (
    <Stack gap={2}>
      <ToastContainer />
      <Box
        component={Paper}
        variant="outlined"
        bgcolor="grey.100"
        sx={{ minHeight: 300 ,maxHeight: 300, p: 2, overflowY:"auto" }}
      >
        {/* <Typography variant="caption">No people already selected</Typography> */}
        <ConditionalRenderer condition={state?.length <= 0}>
          <Typography variant="caption">
            {translator("No people already selected")}
          </Typography>
        </ConditionalRenderer>
        <ConditionalRenderer condition={state?.length > 0}>
          {state?.map((elem: any) => {
            return (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  variant="caption"
                  fontWeight={"700"}
                  sx={{
                    display: "flex",
                    color: "#00AAB0",
                    marginBottom: "4px",
                    background: "#eff1f7",
                    border: "1px solid #00AAB0",
                    borderRadius: "30px",
                    p: "4px",
                    alignItems: "center",
                  }}
                >
                  {elem?.label}
                </Typography>
                <Button onClick={() => handleRemoveClick(elem?.value)}>
                  <ModalCloseIcon />
                </Button>
              </div>
            );
          })}
        </ConditionalRenderer>
      </Box>

      {/* <Stack direction={{ md: 'row' }} gap={2} alignItems={{ md: 'flex-end' }}>
        <FormControl sx={{ flexBasis: { xs: '100%', md: '60%', lg: '40%' } }} disabled>
          <FormLabel>Select people</FormLabel>
          <Select
            placeholder="Please select practices"
          />
        </FormControl>

        <Button variant="contained" disabled>Add new people</Button>
      </Stack> */}
      <Stack direction={{ md: "row" }} gap={2} alignItems={{ md: "flex-end" }}>
        <Autocomplete
          disablePortal
          options={data}
          sx={{ width: 300 }}
          value={selectedValue}
          onChange={handleValueChange}
          renderInput={(params) => (
            <TextField {...params} label={`${translator("support.Select")} ${translator("People")}`} />
          )}
        />
        {/* <Button variant="contained" onClick={onClickHandler}>
          Add new people
        </Button> */}
      </Stack>
    </Stack>
  );
};

export default PeopleInfoForm;
